import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid';
import styled from 'styled-components';
import SectionTitle from './SectionTitle';
import Color from 'constants/colors'

export const Container = styled.div`
	margin-top: 40px;
	display: flex;
	@media screen and (max-width: 767px) {
		flex-direction: column;
	}
`;

export const TitleContainer = styled.div`
	border-top: 2px solid black;
	padding-top: 10px;
	margin-top: 6px;
	margin-right: 40px;
	text-align: right;
	width: 30%;
	@media screen and (max-width: 767px) {
		width: 100%;
		border: none;
		margin: 0;
		text-align: center;
	}
`;

export const Body = styled.div`
	width: calc(70% - 40px);
	@media screen and (max-width: 767px) {
		width: 100%;
	}
`;

const ExpandButton = styled.div`
	margin: 40px auto 0 auto;
	padding: 10px 20px;
	display: flex;
	max-width: 200px;
	align-items: center;
	justify-content: center;
	background-color: black;
	border-radius: 4px;
	@media not all and (hover: none) {
    &:hover{
      background-color: ${Color('purple')};
      cursor: pointer;
    }
  }
`;


const ExpandButtonLabel = styled.h4`
	text-align: center;
	color: white;
`;

const Snippet = (props) => (
	<Container>
		<TitleContainer>
			<h3>{props.title}</h3>
		</TitleContainer>
		<Body>{props.description}</Body>
	</Container>
)


class SummaryList extends React.Component  {
	constructor(props) {
		super(props);
		this.state = {
			expanded: false,
		}
	}

	expandContainer = () => {
		this.setState({expanded: true})
	}

	render() {
		const { title, subtitle, stories } = this.props.data;
		const snippets = stories.map( (story, i) => {
			if(i < this.props.listNItems) {
				return(
					<Snippet key={i} title={story.title} description={story.description}/>
				);
			} else {
				return null
			}
		});
		//-- most readable, but stylistically inelegant way to do this
		let restOfSnippets = stories.map( (story, i) => {
			if(i >= this.props.listNItems) {
				return(
					<Snippet key={i} title={story.title} description={story.description}/>
				);
			} else {
				return null;
			}
		})

		if (restOfSnippets[restOfSnippets.length-1] === null) {
			restOfSnippets = null;
		}
		return(
			<div>
				<Row>
			    <Col 
			    	xsOffset={1} xs={10} 
			      smOffset={1} sm={10} 
			      mdOffset={1} md={10} 
			      lgOffset={1} lg={10}
			    >
					<SectionTitle title={title} subtitle={subtitle}/>
					</Col>
				</Row>
				<Row>
			    <Col 
			    	xsOffset={1} xs={10} 
			      smOffset={2} sm={8} 
			      mdOffset={3} md={6} 
			      lgOffset={3} lg={6}
			    >
					{snippets}
					{(!this.state.expanded && restOfSnippets) && 
						<ExpandButton onClick={this.expandContainer}>
							<ExpandButtonLabel>See more</ExpandButtonLabel>
						</ExpandButton>
					}
					{this.state.expanded && restOfSnippets}

					</Col>
				</Row>
			</div>
		);
	}
}

SummaryList.propTypes = {
	listNItems: PropTypes.number,
}

SummaryList.defaultProps = {
	listNItems: 3,
}

export default SummaryList;


// WEBPACK FOOTER //
// ./src/pages/june-5/races/components/SummaryList.js